import { useRef, useState } from "react";
import { Camera, Pencil, X } from "lucide-react";
import { toast } from "sonner";
import { compressImage } from "@/lib/api";
import PhotoAnnotator from "@/components/PhotoAnnotator";

export const PhotoUpload = ({ photos, setPhotos, max = 6 }) => {
  const inputRef = useRef(null);
  const [editing, setEditing] = useState(null);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    const room = max - photos.length;
    if (!files.length) return;
    if (room <= 0) return toast.error(`${max} photos maximum`);
    const compressed = await Promise.all(files.slice(0, room).map((f) => compressImage(f)));
    setPhotos([...photos, ...compressed]);
    e.target.value = "";
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-3">
        {photos.map((src, i) => (
          <div key={`${src.slice(-32)}-${i}`} className="relative aspect-square rounded-xl overflow-hidden border border-slate-200 group">
            <img src={src} alt={`photo ${i + 1}`} className="h-full w-full object-cover" />
            <button
              type="button"
              data-testid={`photo-annotate-${i}`}
              onClick={() => setEditing(i)}
              className="absolute bottom-1 left-1 rounded-full bg-[#005CFF] text-white p-1.5 hover:bg-[#0047CC] transition-colors"
              title="Annoter la photo"
            >
              <Pencil size={12} />
            </button>
            <button
              type="button"
              data-testid={`photo-remove-${i}`}
              onClick={() => setPhotos(photos.filter((_, idx) => idx !== i))}
              className="absolute top-1 right-1 rounded-full bg-slate-900/80 text-white p-1 hover:bg-red-500 transition-colors"
            >
              <X size={13} />
            </button>
          </div>
        ))}
        {photos.length < max && (
          <button
            type="button"
            data-testid="photo-add-btn"
            onClick={() => inputRef.current?.click()}
            className="aspect-square rounded-xl border-2 border-dashed border-slate-300 text-slate-400 grid place-items-center hover:border-[#005CFF] hover:text-[#005CFF] transition-colors"
          >
            <Camera size={22} />
          </button>
        )}
      </div>
      <input ref={inputRef} data-testid="photo-input" type="file" accept="image/*" multiple capture="environment" className="hidden" onChange={onFiles} />
      <p className="text-xs text-slate-500">
        {photos.length}/{max} photos · compressées automatiquement · touchez le crayon pour entourer la zone en panne
      </p>

      {editing !== null && (
        <PhotoAnnotator
          src={photos[editing]}
          onCancel={() => setEditing(null)}
          onSave={(dataUrl) => {
            setPhotos(photos.map((p, i) => (i === editing ? dataUrl : p)));
            setEditing(null);
            toast.success("Annotation enregistrée");
          }}
        />
      )}
    </div>
  );
};

export default PhotoUpload;
